import React from "react";
import { FiAlertTriangle, FiTrash2 } from "react-icons/fi";

import AdminButton from "../../_shared/ui/AdminButton";
import AdminDrawer from "../../_shared/ui/AdminDrawer";

export default function ProjetsDeleteDrawer({
  open,
  item,
  deleting,
  onClose,
  onConfirm,
}) {
  return (
    <AdminDrawer
      open={open}
      onClose={onClose}
      title="Supprimer le projet"
      subtitle="Cette action est définitive. Le projet ne sera plus disponible."
      icon={FiAlertTriangle}
      size="sm"
      footer={
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <AdminButton variant="secondary" onClick={onClose}>
            Annuler
          </AdminButton>

          <AdminButton
            icon={FiTrash2}
            variant="danger"
            loading={deleting}
            onClick={onConfirm}
          >
            Supprimer
          </AdminButton>
        </div>
      }
    >
      <div className="rounded-[1.7rem] border border-rose-200 bg-rose-50 p-5 dark:border-rose-500/20 dark:bg-rose-500/10">
        <p className="text-sm font-bold text-rose-800 dark:text-rose-200">
          Confirmez-vous la suppression de ce projet ?
        </p>

        <p className="mt-3 text-lg font-bold text-slate-950 dark:text-white">
          {item?.titre || "Projet sélectionné"}
        </p>

        <p className="mt-3 text-sm leading-6 text-rose-700 dark:text-rose-200">
          Une fois supprimé, il ne sera plus visible dans l’administration ni
          sur le site public.
        </p>
      </div>
    </AdminDrawer>
  );
}